import { HTMLAttributes, ReactNode } from 'react';
import styled, { css } from 'styled-components';

import { Grid } from 'coreOld/elements';

type HeaderWrapperProps = HTMLAttributes<HTMLDivElement> & {
  children?: ReactNode;
  borderBottom?: boolean;
};

const HeaderWrapper = styled(Grid)<HeaderWrapperProps>`
  background: ${({ theme }) => theme.palette.backgrounds.columnHeader};
  padding: 5px 16px 5px 32px;
  margin: 0px;

  ${({ borderBottom, theme }) =>
    borderBottom &&
    css`
      border-bottom: ${`1px solid ${theme.palette.tableBorderColor}`};
    `}
`;

export default HeaderWrapper;
